import Route from "./Route";
import { useNavigate } from "react-router-dom";
import { RiDashboard3Fill } from "react-icons/ri";
import useAuth from "../useAuth";
import logo from "../assets/logo.jpg";
import { IoPersonSharp } from "react-icons/io5";
import { History } from "@mui/icons-material";

export default function NavBar() {
  const navigate = useNavigate();
  const { user, menuOpen, changeMenuSize } = useAuth();

  return (
    <div className="relative bg-[#1e1e2f] w-full h-screen pt-2 shadow-lg">
      {menuOpen && (
        <div className="flex w-28 h-28 rounded-full mx-auto bg-white items-center justify-between px-6 py-4 text-white">
          <img
            src={logo}
            className="w-24 h-24 object-contain rounded-full"
            alt="logo"
          />
        </div>
      )}
      {menuOpen && (
        <div className="text-xl text-white text-center font-bold tracking-wide uppercase mt-2">
          BRAVISHMAH
        </div>
      )}

      {!menuOpen && (
        <div className="flex w-20 h-20 mx-auto rounded-full bg-white items-center justify-center  text-white">
          <img
            src={logo}
            className="w-14 h-14 object-contain rounded-full "
            alt="logo"
          />
        </div>
      )}

      <div className="mt-6">
        {user?.userType === "admin" && (
          <div>
            <Route
              name="Home"
              onClick={() => navigate("home")}
              icon={<RiDashboard3Fill />}
              urlPath="home"
              isCollapsed={!menuOpen}
            />

            <Route
              name="RequestLogs"
              onClick={() => navigate("requestLogs")}
              icon={<History />}
              urlPath="requestLogs"
              isCollapsed={!menuOpen}
            />
          </div>
        )}

        <Route
          name="Profile"
          onClick={() => navigate("profile")}
          urlPath="profile"
          icon={<IoPersonSharp />}
          isCollapsed={!menuOpen}
        />
      </div>
    </div>
  );
}
